var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SessionList',{staticClass:"mt-3",attrs:{"userId":_vm.userId},on:{"selectSession":_vm.onSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }